export default __webpack_public_path__ + "static/media/spotter-logo.e6d70a97.svg";